import { type CustomerDTO } from "@ifa/utils";
import { BeneficiarySection } from "../../CustomerDetail/components/beneficiary/BeneficiarySection";

interface BeneficiaryViewProps {
  customer: CustomerDTO | null;
  onBack: () => void;
}

export function BeneficiaryView({ customer }: BeneficiaryViewProps) {
  return (
    <div style={{
      height: "100%",
      overflow: "auto",
    }}>
      <BeneficiarySection
        customer={customer}
        onRefresh={() => {}}
        fromCustomerList={true}
        customerId={customer?.customerId}
      />
    </div>
  );
}
